export default {"src":"/_next/static/media/icon_template_sync.869df339.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};